
document.documentElement.classList.remove('no-js');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('is-visible');
  });
}, { threshold: 0.08 });

document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

document.querySelectorAll('[data-countdown]').forEach((wrap) => {
  const target = new Date();
  target.setHours(23,59,59,999);

  const tick = () => {
    const diff = Math.max(0, target - new Date());
    const h = String(Math.floor(diff / 3600000)).padStart(2,'0');
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2,'0');
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2,'0');
    const values = wrap.querySelectorAll('span');
    if (values[0]) values[0].textContent = h;
    if (values[1]) values[1].textContent = m;
    if (values[2]) values[2].textContent = s;
  };
  tick();
  setInterval(tick,1000);
});

// Swipeable product carousels with desktop arrow controls.
document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const prev = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!track) return;

  const step = () => {
    const card = track.querySelector('.product-card');
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
    return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  };

  const updateButtons = () => {
    if (!prev || !next) return;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  };

  prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  track.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
});
